// src/components/Sections/GroupsExperienceSection/GroupsExperienceSection.jsx

import React from 'react';
import './GroupsExperienceSection.scss';
import groupScreenshot from '../../../assets/images/marketing/ttg-groups-phone.png';
import useInView from '../../../hooks/useInView';

const sampleStandings = [
  { place: '01', name: 'Jack Jameson', points: '10' },
  { place: '02', name: 'Paul Jameson', points: '7' }
];

const features = [
  {
    number: '01',
    title: 'Start a shared round',
    description: 'Choose the course, tees, and which friends are playing.'
  },
  {
    number: '02',
    title: 'Keep individual scores',
    description: 'Each player records their own round within the same group outing.'
  },
  {
    number: '03',
    title: 'Build season standings',
    description: 'Handicap-adjusted results add points and give the group a reason to play again.'
  }
];

export default function GroupsExperienceSection() {
  const { ref, isVisible } = useInView({ threshold: 0.2 });

  return (
    <section
      id="groups"
      ref={ref}
      className={`groups-v4 section-v2 section-v2--dark motion-section ${isVisible ? 'is-visible' : ''}`}
    >
      <div className="groups-v4__texture" aria-hidden="true" />

      <div className="container groups-v4__layout">
        <div className="groups-v4__visual">
          <span className="groups-v4__ghost" aria-hidden="true">GROUP PLAY</span>

          <div className="groups-v4__board" aria-label="Illustrative group season standings">
            <div className="groups-v4__board-header">
              <div>
                <small>Group Tour</small>
                <strong>Made It Out Of The Chat</strong>
              </div>
              <span className="groups-v4__season">Example standings</span>
            </div>

            <div className="groups-v4__board-meta">
              <span>2 Members</span>
              <span>1 Shared Round</span>
              <span>Season points</span>
            </div>

            <div className="groups-v4__board-columns">
              <span>Pos</span>
              <span>Player</span>
              <span>Pts</span>
            </div>

            {sampleStandings.map((player) => (
              <div className="groups-v4__board-row" key={player.name}>
                <span>{player.place}</span>
                <strong>{player.name}</strong>
                <b>{player.points}</b>
              </div>
            ))}

            <div className="groups-v4__board-footer">
              <span>Season standings</span>
              <strong>Every shared round counts.</strong>
            </div>
          </div>

          <figure className="groups-v4__phone">
            <img
              src={groupScreenshot}
              alt="The Tour Golfers group season standings screen"
              loading="lazy"
            />
          </figure>
        </div>

        <div className="groups-v4__copy motion-copy">
          <p className="eyebrow eyebrow--light">02 · Your group</p>
          <h2>Your foursome finally has a home.</h2>
          <p className="groups-v4__lead">
            Create a group with the people you already play with. Shared rounds
            connect everyone&apos;s scores, with handicap-adjusted results, season
            points, and standings that carry beyond the eighteenth green.
          </p>

          <div className="groups-v4__features">
            {features.map((feature) => (
              <div className="groups-v4__feature" key={feature.number}>
                <span className="groups-v4__feature-number">{feature.number}</span>
                <div>
                  <strong>{feature.title}</strong>
                  <p>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>

          <p className="experience-quote experience-quote--light">
            Bragging rights should last longer than the parking lot.
          </p>
        </div>
      </div>
    </section>
  );
}
